import { useMemo } from 'react';

import { PortfolioTypes } from '~/models/PortfolioType';

import { useTradingPortfolioQuery } from './queries/portfolios/trading/useTradingPortfolioQuery';
import { useGetUserPortfolios } from './queries/portfolios/useGetUserPortfolios';

/** Return the user's portfolio ID based on the intended deposit destination (managed or trading). */
export const useGetDepositPortfolioID = (destinationPortfolio: PortfolioTypes) => {
    const { data: portfolios } = useGetUserPortfolios();
    const { data: trading } = useTradingPortfolioQuery();

    const portfolioID = useMemo(
        () => ({
            trading: trading?.id,
            managed: portfolios?.portfolios?.find((portfolio) => portfolio.type === PortfolioTypes.managed)?.id,
            wine: portfolios?.portfolios?.find((portfolio) => portfolio.type === PortfolioTypes.wine)?.id,
            whiskey: portfolios?.portfolios?.find((portfolio) => portfolio.type === PortfolioTypes.whiskey)?.id
        }),
        [portfolios, destinationPortfolio, trading?.id]
    );

    const depositPortfolioID: string | undefined = portfolioID[destinationPortfolio];

    return { depositPortfolioID };
};
